module.exports = __webpack_public_path__ + "static/media/AramarkSmartShopper.42c1a97a.png";